import { Suspense } from 'react';

import PageSuspense from '@/components/UI/PageSuspense';
import DMReceiptList from './DMReceiptList';
import DMStaffList from './DMStaffList';

export default function DMPageWrapper({ chatId = 'me' }: { chatId: API.Id | 'me' }) {
  return (
    <div
      // Two panes: the conversation list (w-72) and the open conversation. Below lg
      // they're a full-width horizontal snap carousel (one pane at a time, with a
      // back button in the conversation header) — the right pattern whenever there
      // isn't room for both beside the app chrome. From md up the app sidebar is a
      // fixed 288px column that <main> clears with pl-72; between md and lg that
      // leaves under ~480px, too little for a 288px list AND a usable conversation,
      // so the carousel (not a squeezed two-column) runs there. Only at lg+ is there
      // room to show both side by side. The old code switched to two columns at md,
      // where they overflowed: the conversation pane couldn't shrink, so the wrapper
      // scrolled the list left and slid its names under the sidebar, clipping them
      // (#1984). lg:snap-none + lg:overflow-x-hidden stop any carousel scroll once
      // both panes are shown; the conversation pane shrinks to fit via lg:min-w-0.
      className={`scrollbar-hidden flex h-40 min-h-[stretch] w-full shrink grow snap-x snap-mandatory snap-always flex-row overflow-x-auto overscroll-contain lg:w-auto lg:snap-none lg:overflow-x-hidden`}
    >
      <Suspense>
        <DMStaffList chatId={chatId} />
      </Suspense>
      <div
        id="chat-content"
        // The conversation pane carries its own top bar (DMReceiptList), so it
        // owns its top safe-area inset separately from the list pane beside it,
        // and takes the layout's fallback while that bar is still loading
        // (#2053) — see renderer/utils/safeTop.tsx.
        // Below lg this is one carousel pane: flex-none + w-full make it exactly one
        // content-area screenful (viewport minus the app sidebar), so a single-pane
        // (member) view fills the area and the staff list↔conversation carousel snaps
        // cleanly. w-[100dvw] here was viewport-wide, so with the sidebar shown the
        // pane overflowed and the row scroll slid the list under the sidebar (#1984).
        // At lg+ it flexes to fill the space left of the 288px list (lg:flex-1) and
        // drops its content min-width (lg:min-w-0) so it never forces an overflow.
        className="flex w-full max-w-full flex-none snap-start flex-col justify-between lg:w-auto lg:flex-1 lg:min-w-0"
      >
        <PageSuspense>
          {/* key={chatId} remounts the detail on chat switch so it can't keep the
              prior chat's newestItem/oldestItem (which briefly flashed the old
              messages before the new fetch). A fresh mount is pending+empty, so
              the SkeletonMessages loader shows during load. (#1533) */}
          <DMReceiptList key={chatId} chatId={chatId} />
        </PageSuspense>
      </div>
    </div>
  );
}
